import { parse, isValid, compareAsc } from 'date-fns'

export const momentToDateFns = (momentObj) => {
  const momentAsString = momentObj && typeof momentObj === 'object' ? momentObj.toString() : momentObj

  const rightNow = Date.now()

  // dateFns.parseISO will not support the formst 'MMM dd yyyy', but parse does.
  const convertedDateFNS = parse(momentAsString.substr(4, 11), 'MMM dd yyyy', rightNow)
  // Return null because the startMonth wasn't a moment().
  if (!isValid(convertedDateFNS)) return null

  // Return null if the parsed date ends up being the same as the default.
  if (compareAsc(rightNow, convertedDateFNS) === 0) return null

  return convertedDateFNS
}
